<template>
  <f7-page class="page-live-chat" @page:afterin="pageAfterIn" @page:afterout="pageAfterOut" :page-content="false">
    <f7-navbar title="LiveChat" backLink="Trở lại"></f7-navbar>
    <f7-page-content>
      <iframe src="https://jivo.chat/m4NYwIHnBX" frameborder="0" width="100%" height="100%"></iframe>
    </f7-page-content>
  </f7-page>
</template>
<script>
export default {
  methods: {
    pageAfterIn(){
      //this.$showJivo();
    },
    pageAfterOut(){
      //this.$hideJivo();
    },
  }
};
</script>
